import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/permission_description",
    name: "permission_description",
    component: () => import("../views/PermissionDescriptionView.vue"),
  },
  {
    path: "/personal_information",
    name: "personal_information",
    component: () => import("../views/PersonalInformationView.vue"),
  },
  {
    path: "/privacy_policy",
    name: "privacy_policy",
    component: () => import("../views/PrivacyPolicyView.vue"),
  },
  {
    path: "/privacy_policy_brief",
    name: "privacy_policy_brief",
    component: () => import("../views/PrivacyPolicyViewBrief.vue"),
  },
  {
    path: "/SDK",
    name: "SDK",
    component: () => import("../views/SDKView.vue"),
  },
  {
    path: "/user_agreement",
    name: "user_agreement",
    component: () => import("../views/UserAgreementView.vue"),
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("../views/FAQView.vue"),
  },
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/mdlPlace",
    name: "mdlPlace",
    component: () => import("../views/MdlPlaceView.vue"),
    meta: {
      noHeader: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next("/");
  } else {
    next();
  }
});

export default router;
